import Layout from "../layout";

// 侧边栏路由
const menuRouter = {
  path: "/",
  name: "框架",
  component: Layout,
  children: [
    {
      path: "/",
      name: "首页",
      component: () => import("../views/index"),
    },
    {
      path: "/search",
      name: "搜索结果",
      component: () => import("../views/search"),
    },
    {
      path: "/destination/region/:region",
      name: "目的地区域",
      component: () => import("../views/destinationRegion"),
    },
    {
      path: "/destination/:id",
      name: "目的地详情",
      component: () => import("../views/destinationDetail"),
    },
    {
      path: "/guide/:type",
      name: "旅游指南",
      component: () => import("../views/guide"),
    },
    {
      path: "/plan-trip",
      name: "定制我的旅程",
      component: () => import("../views/planTrip"),
    },
    {
      path: "/strategy",
      name: "游玩攻略",
      component: () => import("../views/strategy"),
    },
    {
      path: "/strategyDetail",
      name: "攻略详情",
      component: () => import("../views/strategyDetail"),
    },
    {
      path: "/contact",
      name: "联系我们",
      component: () => import("../views/contact"),
    },
    {
      path: "/about",
      name: "关于寰纵",
      component: () => import("../views/about"),
    },
  ],
};
export default menuRouter;
